import React from "react";

const GiftCardProgressBar = ({ steps = [], currentStep = 0 }) => {
  return (
    <div className="bg-white">
      <div className="flex items-center justify-between gap-4">
        {steps.map((label, index) => {
          // const isCompletedOrActive = index <= currentStep;
          const isCompletedOrActive = index === currentStep; // ✅ highlight only current
          return (
            <div
              key={index}
              className={`flex flex-col items-start flex-1 ${
                index > 0 ? "" : ""
              }`}
            >
              <div
                className={`w-full h-[2px] mb-2 ${
                  isCompletedOrActive ? "bg-[#00ADEF]" : "bg-[#8C8C8C]"
                }`}
              ></div>
              <span
                className={`text-[10px] font-medium whitespace-nowrap text-left ${
                  isCompletedOrActive ? "text-[#00ADEF]" : "text-[#8C8C8C]"
                }`}
              >
                {label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default GiftCardProgressBar;
